import {DiplomatObjectNames, diplomatObjectSchema} from 'types/diplomat-object';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import * as yup from 'yup';

export const SamlSettingsNames = {
   idpEntityId: 'idpEntityId',
   idpSingleSignOnServiceUrl: 'idpSingleSignOnServiceUrl',
   idpSingleLogoutServiceUrl: 'idpSingleLogoutServiceUrl',
   idpX509CertificateId: 'idpX509CertificateId',
   enabled: 'enabled',
   spEntityId: 'spEntityId',
} as const;

export const SamlSettingsSchema = diplomatObjectSchema.shape({
   [DiplomatObjectNames.objectType]: yup
      .string()
      .oneOf(DiplomatObjectType.keys)
      .default(DiplomatObjectType.enum.SAML_SETTINGS),
   [SamlSettingsNames.idpEntityId]: yup.string(), //.required('Required'),
   [SamlSettingsNames.idpSingleSignOnServiceUrl]: yup.string(),
   // .url('Must be a valid URL')
   //.required('Required'),
   [SamlSettingsNames.idpSingleLogoutServiceUrl]: yup.string(), //.url('Must be a valid URL'),
   [SamlSettingsNames.idpX509CertificateId]: yup.string(), //.required('Required'),
   [SamlSettingsNames.enabled]: yup.bool(),
   [SamlSettingsNames.spEntityId]: yup.string().default('DiplomatMFT.SSO'),
});

export type ISamlSettings = yup.InferType<typeof SamlSettingsSchema>;
